import { IdentityOemMapping } from 'common/types/Entities';

import { _request, APIBaseResponse, APIMethod } from '..';

const IDENTITIES_PREFIX = '/identities';

export interface APIIdentitiesesGetByIdParams {
    userId: string;
    noCache?: boolean;
}

type APIUserProfilesGetResponse = APIBaseResponse<IdentityOemMapping[]>;

export const APIIdentitiesByIdGetList: APIMethod<APIIdentitiesesGetByIdParams, APIUserProfilesGetResponse> = (params) => {
    let url = `${IDENTITIES_PREFIX}/${params.userId}`;

    if (params.noCache !== undefined) {
        url += `?noCache=${params.noCache}`;
    }

    return _request('GET', url);
};
